module.exports = __webpack_public_path__ + "img/swift-boostergreen-glx-rojo-vulcano.bdb32e61.png";